import React from 'react';
import PropTypes from 'prop-types';
import { StyledTitle, StyledIconPng, StyledIcon, StyledText } from './style';
import { StyledIconNavPlata } from '../GeneralList/style';
import { Usuario, Download } from '../../../../assets/images/index';

const TitleWidget = ({
  preTitle,
  title,
  type,
  icon,
  className,
  small,
  size,
  downloadIcon
}) => (
  <StyledTitle type={type} className={className} small={small}>
    {typeof icon === 'string' ? (
      <StyledIconPng size={size} src={icon} type={type} small={small} />
    ) : (
      <StyledIcon size={size} svg={icon} type={type} small={small} />
    )}
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <StyledText small={small}>
        {preTitle && <StyledText small={small}>{preTitle}</StyledText>}
        {title && <StyledText small={small}>{title}</StyledText>}
      </StyledText>
      {downloadIcon && (
        <StyledIconNavPlata svg={Download} size="s" color="dark" hover />
      )}
    </div>
  </StyledTitle>
);

TitleWidget.propTypes = {
  preTitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string
    })
  ]),
  className: PropTypes.string,
  small: PropTypes.bool,
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'sm', 'smm', 'm', 'l', 'xl']),
  downloadIcon: PropTypes.bool
};

TitleWidget.defaultProps = {
  preTitle: '',
  type: 'colorOne',
  icon: Usuario,
  small: false,
  size: 'xl',
  downloadIcon: false
};

export default TitleWidget;
